/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { createContext } from 'preact';

/**
 * Sortable Context
 */
type SortableContextProps = {
  isRendered?: boolean;

  sortable?: 'enabled' | 'disabled';

  sortDirection?: 'ascending' | 'descending' | 'unsorted';

  onSort?: () => void;

  isTabbable?: boolean;
};

/**
 * Context which the parent custom element components can use for passing down
 * the sort context
 */
export const SortableContext = createContext<SortableContextProps>({});
